import React, { useCallback } from "react";
import { Button, Grid, Header, Icon, Input, Modal } from "semantic-ui-react";
import { connect, useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { socket } from "../../../../lib/socketio";
import Footer from "../../Footer";
import {
  Acc,
  Line,
  PumpLeft,
  REF,
  Tank,
  Valve,
  ValveVertical,
  // update for SOFC
  MIX,
  HEX_SOFC,
  ATO,
  Stack_SOFC,
  Fan_Animate,
  HEX_SOFC_small,
} from "../../../Definitions/GraphicComponents";
import ClearOverride from "../../../Macros/ClearOverride";
import ActivateOverride from "../../../Macros/ActivateOverride";
import { setHasHeaderReceived } from "../../../../actions/headerActions";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { GRAPHICS_WRITE, isAuthorized } from "../../../../lib/authorization";

const PSMOvr_S300_PSM4 = ({ hasHeaderReceived }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [anovrdata, setAnOvrdata] = React.useState([]);
  const [digovrdata, setDigOvrdata] = React.useState([]);
  const [isCopied, setIsCopied] = React.useState(false);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [tempovrdigdata, settempovrdigdata] = React.useState({});
  const [tagdata, settagdata] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [overrideVisible, setOverrideVisible] = React.useState({
    visible: true,
  });
  const [dataCopy, setDataCopy] = React.useState();
  const [checkdata, setcheckdata] = React.useState("");
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0 && hasHeaderReceived) {
      socket.emit("get tag names", [{ display_id: 280 }, { display_id: 130 }]);
      socket.on("receive tag names", (data) => {
        const isFound = data.tags_data.some(
          (element) => element.display_id === 280,
        );
        if (isFound) {
          settags(data.tags_data);
        }
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags, hasHeaderReceived]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 130 ? [t] : []));

  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'Plant Overview - Graphical' ? [t] : []);
    t.display_id === 280 ? [t] : [],
  );
  const display = GenTags.map((t) => t.page_name);

  const SysDigTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "DIN" || t.name.slice(5, 9) === "DOUT" ? [t] : [],
  );

  const SysAnTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "AIN" || t.name.slice(5, 9) === "AOUT" ? [t] : [],
  );

  const ClearDigIds = SysDigTags.map((t) => t.id);
  const ClearAnIds = SysAnTags.map((t) => t.id);

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const planttags = [];
  let rows;
  const length = GenTags.length;
  rows = Math.round(length / 4);
  let i = 0;
  while (i < length) {
    planttags.push(GenTags.slice(i, i + rows));
    i += rows;
  }

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 400);
    return () => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const parentcallbackAn = useCallback((flag) => {
    if (flag === true) {
      setAnOvrdata([]);
      setIsCopied(false);
      settags([]);
      settags([]);
    }
  }, []);

  const parentcallbackDig = useCallback((flag) => {
    if (flag === true) {
      setDigOvrdata([]);
      // setIsCopied(false);
      settags([]);
      setDataCopy({});
    }
  }, []);

  const getDigVal = (value, name) => {
    if (typeof value === "undefined") {
      return "";
    }
    if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      if (name === "CV720" || name === "CV710" || name === "CV713") {
        // PPC에서 처리되지 않은 normal open
        if (value === 0) {
          return "OPEN";
        } else return "CLOSED";
      } else {
        if (value === 0) {
          return "CLOSED";
        } else return "OPEN";
      }
    } else {
      if (value === 0) {
        return "OFF";
      } else return "ON";
    }
  };

  const setOverrideVisiblity = () => {
    setOverrideVisible({
      ...overrideVisible,
      visible: !overrideVisible.visible,
    });
  };

  const handleCheck = (event, obj_key) => {
    if (event.target.id === "1") {
      if (
        obj_key === 10258 ||
        obj_key === 10252 ||
        obj_key === 30451 ||
        obj_key === 14172 ||
        obj_key === 14166 ||
        obj_key === 31858 ||
        obj_key === 18086 ||
        obj_key === 18080 ||
        obj_key === 33265 ||
        obj_key === 22000 ||
        obj_key === 21994 ||
        obj_key === 34672 ||
        obj_key === 25914 ||
        obj_key === 25908 ||
        obj_key === 36079
      ) {
        setcheckdata(0);
        setDataCopy({ ...dataCopy, [obj_key]: 0 });
      } else {
        setcheckdata(1);
        setDataCopy({ ...dataCopy, [obj_key]: 1 });
      }
    } else if (event.target.id === "0") {
      if (
        obj_key === 10258 ||
        obj_key === 10252 ||
        obj_key === 30451 ||
        obj_key === 14172 ||
        obj_key === 14166 ||
        obj_key === 31858 ||
        obj_key === 18086 ||
        obj_key === 18080 ||
        obj_key === 33265 ||
        obj_key === 22000 ||
        obj_key === 21994 ||
        obj_key === 34672 ||
        obj_key === 25914 ||
        obj_key === 25908 ||
        obj_key === 36079
      ) {
        setcheckdata(1);
        setDataCopy({ ...dataCopy, [obj_key]: 1 });
      } else {
        setcheckdata(0);
        setDataCopy({ ...dataCopy, [obj_key]: 0 });
      }
    }
  };

  const handleChange = (e, { value }) => {
    settagdata(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleOpen = (id) => {
    setOpen({ ...open, [id]: true });
  };

  const handleClose = (id) => {
    settagdata("");
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      delete dataCopy[id];
    }
    setcheckdata("");
    setOpen({ ...open, [id]: false });
  };

  const handleToggle = (event, id) => {
    event.preventDefault();
    var datavalue;
    if (typeof tagdata === "undefined" || tagdata === "") {
      datavalue = data[id];
    } else datavalue = tagdata;
    var writedata = { tag_id: id, tag_value: datavalue, isOverriden: 1 };
    settempovrdata({ ...tempovrdata, [id]: datavalue });
    settempoverriden({ ...tempoverridden, [id]: 1 });
    var index = anovrdata.findIndex((x) => x.tag_id === id);
    if (typeof anovrdata[index] === "undefined") {
      anovrdata.push(writedata);
    } else {
      anovrdata[index] = { tag_id: id, tag_value: datavalue, isOverriden: 1 };
    }
    setOpen({ ...open, [id]: false });
    settagdata("");
  };

  const handleDigToggle = (event, id) => {
    event.preventDefault();
    var boolvalue;
    if (typeof checkdata === "undefined" || checkdata === "") {
      boolvalue = data[id];
    } else {
      boolvalue = checkdata;
    }
    if (id === 34669 || id === 34672) {
      var writedata1 = { tag_id: 34669, tag_value: boolvalue, isOverriden: 1 };
      var writedata2 = { tag_id: 34672, tag_value: boolvalue, isOverriden: 1 };
      var index1 = digovrdata.findIndex((x) => x.tag_id === 34669);
      var index2 = digovrdata.findIndex((x) => x.tag_id === 34672);
      if (
        typeof digovrdata[index1] === "undefined" &&
        typeof digovrdata[index2] === "undefined"
      ) {
        digovrdata.push(writedata1, writedata2);
      } else {
        digovrdata[index1] = {
          tag_id: 34669,
          tag_value: boolvalue,
          isOverriden: 1,
        };
        digovrdata[index2] = {
          tag_id: 34672,
          tag_value: boolvalue,
          isOverriden: 1,
        };
      }
      settempovrdigdata({
        ...tempovrdigdata,
        34669: boolvalue,
        34672: boolvalue,
      });
      settempoverriden({ ...tempoverridden, 34669: 1, 34672: 1 });
    } else {
      var writedata = { tag_id: id, tag_value: boolvalue, isOverriden: 1 };
      var index = digovrdata.findIndex((x) => x.tag_id === id);
      if (typeof digovrdata[index] === "undefined") {
        digovrdata.push(writedata);
      } else {
        digovrdata[index] = {
          tag_id: id,
          tag_value: boolvalue,
          isOverriden: 1,
        };
      }
      settempoverriden({ ...tempoverridden, [id]: 1 });
      settempovrdigdata({ ...tempovrdigdata, [id]: boolvalue });
    }
    setOpen({ ...open, [id]: false });
    setcheckdata("");
  };

  const handleClear = (event, id) => {
    event.preventDefault();
    var adiodata = {
      buttonClickType: "Clear Individual Analog Overrides",
      tags: [id],
    };
    socket.emit("button click", adiodata);
    delete tempovrdata[id];
    delete tempoverridden[id];
    setOpen({ ...open, [id]: false });
    var index = anovrdata.findIndex((x) => x.tag_id === id);
    if (index >= 0) {
      anovrdata.splice(index, 1);
    }

    var col_idx = tags.findIndex((x) => x.id === id);
    tags[col_idx].isOverriden = 0;
  };

  const handleDigClear = (event, id) => {
    event.preventDefault();
    if (id === 34669 || id === 34672) {
      var adiodata = {
        buttonClickType: "Clear Individual Digital Overrides",
        tags: [34669, 34672],
      };
      socket.emit("button click", adiodata);
      setOpen({ ...open, [id]: false });
      delete tempovrdigdata[34669];
      delete tempovrdigdata[34672];
      delete tempoverridden[34669];
      delete tempoverridden[34672];
      if (
        typeof dataCopy !== "undefined" &&
        (34669 in dataCopy || 34672 in dataCopy)
      ) {
        delete dataCopy[34669];
        delete dataCopy[34672];
      }
      var index1 = digovrdata.findIndex((x) => x.tag_id === 34669);
      var index2 = digovrdata.findIndex((x) => x.tag_id === 34672);
      var idsToRemove = [index1, index2];
      for (let j = idsToRemove.length - 1; j >= 0; j--) {
        digovrdata.splice(idsToRemove[j], 1);
      }
      var col_idx1 = tags.findIndex((x) => x.id === 34669);
      var col_idx2 = tags.findIndex((x) => x.id === 34672);
      tags[col_idx1].isOverriden = 0;
      tags[col_idx2].isOverriden = 0;
      setIsCopied(false);
    } else {
      var adiodata = {
        buttonClickType: "Clear Individual Digital Overrides",
        tags: [id],
      };
      socket.emit("button click", adiodata);
      setOpen({ ...open, [id]: false });
      delete tempovrdigdata[id];
      delete tempoverridden[id];
      if (typeof dataCopy !== "undefined" && id in dataCopy) {
        delete dataCopy[id];
      }
      var index = digovrdata.findIndex((x) => x.tag_id === id);
      if (index >= 0) {
        digovrdata.splice(index, 1);
      }
      var col_idx = tags.findIndex((x) => x.id === id);
      tags[col_idx].isOverriden = 0;
      setIsCopied(false);
    }
  };

  const CheckOnOp = (name) => {
    if (
      name === "IORack5Status" ||
      name === "IORack6Status" ||
      name === "LOI Shutdown" ||
      name === "LOR Enable" ||
      name === "Cust Norm SD"
    ) {
      return "SD";
    } else if (name === "GFD_Bender") {
      return "FAULT";
    } else if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      return "OPEN";
    } else {
      return "ON";
    }
  };

  const CheckOffOp = (name) => {
    if (
      name === "IORack5Status" ||
      name === "IORack6Status" ||
      name === "LOI Shutdown" ||
      name === "LOR Enable" ||
      name === "Cust Norm SD" ||
      name === "GFD_Bender"
    ) {
      return "OK";
    } else if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      return "CLOSED";
    } else {
      return "OFF";
    }
  };

  const getCheckEnable = (id) => {
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      if (
        id === 10258 ||
        id === 10252 ||
        id === 30451 ||
        id === 14172 ||
        id === 14166 ||
        id === 31858 ||
        id === 18086 ||
        id === 18080 ||
        id === 33265 ||
        id === 22000 ||
        id === 21994 ||
        id === 34672 ||
        id === 25914 ||
        id === 25908 ||
        id === 36079
      ) {
        if (dataCopy[id] === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (dataCopy[id] === 1) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (
        id === 10258 ||
        id === 10252 ||
        id === 30451 ||
        id === 14172 ||
        id === 14166 ||
        id === 31858 ||
        id === 18086 ||
        id === 18080 ||
        id === 33265 ||
        id === 22000 ||
        id === 21994 ||
        id === 34672 ||
        id === 25914 ||
        id === 25908 ||
        id === 36079
      ) {
        if (data[id] === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        if (data[id] === 1) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const getCheckDisable = (id) => {
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      if (
        id === 10258 ||
        id === 10252 ||
        id === 30451 ||
        id === 14172 ||
        id === 14166 ||
        id === 31858 ||
        id === 18086 ||
        id === 18080 ||
        id === 33265 ||
        id === 22000 ||
        id === 21994 ||
        id === 34672 ||
        id === 25914 ||
        id === 25908 ||
        id === 36079
      ) {
        if (dataCopy[id] === 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (dataCopy[id] === 0) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if (
        id === 10258 ||
        id === 10252 ||
        id === 30451 ||
        id === 14172 ||
        id === 14166 ||
        id === 31858 ||
        id === 18086 ||
        id === 18080 ||
        id === 33265 ||
        id === 22000 ||
        id === 21994 ||
        id === 34672 ||
        id === 25914 ||
        id === 25908 ||
        id === 36079
      ) {
        if (data[id] === 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (data[id] === 0) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const grid = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column width={5} style={styles.name}>
          {typeof data !== "undefined" &&
          data !== null &&
          typeof data[tag_id] !== "undefined"
            ? tag_id === 12941
              ? data[tag_id].toFixed(3)
              : data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column width={7} style={styles.gridUnit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tag_id === 6273 || tag_id === 6280
              ? "SP"
              : tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "grey",
            fontSize: "18px",
            fontWeight: "bold",
            marginLeft: "5px",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const grid_analog_reverse = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row style={{ paddingBottom: "4px", marginBottom: "0px" }}>
          <Grid.Column
            style={{
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginLeft: "5px",
              marginTop: "0px",
              paddingTop: "0px",
            }}
          >
            {typeof tags !== "undefined" &&
            tags !== null &&
            tags.length > 0 &&
            tags.findIndex((x) => x.id === tag_id) !== -1
              ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              : ""}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            paddingTop: "0px",
            marginTop: "0px",
            maxWidth: "800px",
            paddingBottom: "0px",
            marginBottom: "0px",
          }}
        >
          <Grid.Column width="6" style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              compact
              inverted
              color="grey"
              size="tiny"
              disabled={
                electronApp
                  ? false
                  : !isAuthorized(
                      user.hmi_role,
                      tags[tags.findIndex((x) => x.id === tag_id)].hmi_security,
                    )
              }
              content={
                typeof data[tag_id] !== "undefined"
                  ? tag_id === 12941
                    ? Math.round(data[tag_id] * 1000) / 1000
                    : Math.round(data[tag_id] * 100) / 100
                  : ""
              }
              // content={Math.round(data[r.id]*100)/100}
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Analog Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <Input
                    focus
                    autoFocus
                    placeholder="Value"
                    style={styles.input}
                    name="Input change"
                    label={
                      tags[tags.findIndex((x) => x.id === tag_id)].unit || ""
                    }
                    labelPosition="right"
                    type="number"
                    step="0.00001"
                    size="small"
                    min={tags[tags.findIndex((x) => x.id === tag_id)].min}
                    max={tags[tags.findIndex((x) => x.id === tag_id)].max}
                    onChange={(event, value) => handleChange(event, value)}
                    defaultValue={data[tag_id]}
                  />
                </form>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>

          <Grid.Column style={styles.unit}>
            {tags[tags.findIndex((x) => x.id === tag_id)].unit}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingTop: "0px",
            marginTop: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{ color: "#f5c71a", paddingTop: "0", fontSize: "16px" }}
          >
            {" "}
            {tempovrdata[tag_id]}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital_reverse = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            maxWidth: "800px",
            paddingBottom: "0px",
            marginBottom: "0px",
          }}
        >
          <Grid.Column style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              color="grey"
              size="tiny"
              inverted
              compact
              style={styles.textwrap}
              disabled={
                electronApp
                  ? false
                  : !isAuthorized(
                      user.hmi_role,
                      tags[tags.findIndex((x) => x.id === tag_id)].hmi_security,
                    )
              }
              content={
                tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{ paddingTop: "0px", marginTop: "0px", paddingLeft: "10px" }}
        >
          <Grid.Column
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital_side = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            maxWidth: "800px",
            paddingBottom: "0px",
            marginBottom: "0px",
          }}
        >
          <Grid.Column width={7} style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              color="grey"
              size="tiny"
              inverted
              compact
              style={styles.textwrap}
              disabled={
                electronApp
                  ? false
                  : !isAuthorized(
                      user.hmi_role,
                      tags[tags.findIndex((x) => x.id === tag_id)].hmi_security,
                    )
              }
              content={
                tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>

          <Grid.Column
            width={9}
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={styles.row}>
          <Grid.Column style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              inverted
              color="grey"
              size="tiny"
              compact
              style={styles.textwrap}
              disabled={
                electronApp
                  ? false
                  : !isAuthorized(
                      user.hmi_role,
                      tags[tags.findIndex((x) => x.id === tag_id)].hmi_security,
                    )
              }
              content={
                tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const colorByRange = (tag_id) => {
    let color = "red";
    // color={(typeof data !== 'undefined' && data !== null && data['7828'] === 95) ? 'green' : (data['2993'] === 5 ? 'yellow' : 'red')}
    if (data[tag_id] >= 5 && data[tag_id] < 95) {
      color = "yellow";
    } else if (data[tag_id] >= 95) {
      color = "green";
    } else {
      color = "red";
    }
    return color;
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <div style={styles.innerdiv}>
        <div style={{ float: "left" }}>
          {(electronApp || isAuthorized(user.hmi_role, GRAPHICS_WRITE)) && (
            <div style={styles.menu}>
              <ClearOverride
                tagid={ClearAnIds}
                tags={tags}
                settags={settags}
                option={3}
                title={"CLEAR ALL PSM4 ANALOG OVERRIDES"}
                channel={"Clear All PSM4 Analog Overrides"}
                settempovrdata={settempovrdata}
                settempoverriden={settempoverriden}
                parentCallback={parentcallbackAn}
              />
              <ActivateOverride
                ovrdata={anovrdata}
                tags={tags}
                settags={settags}
                option={2}
                title={"ACTIVATE ALL PSM4 ANALOG OVERRIDES"}
                channel={"Activate All PSM4 Analog Overrides"}
                parentCallback={parentcallbackAn}
                tempovrdata={tempovrdata}
                settempovrdata={settempovrdata}
                tempoverridden={tempoverridden}
                settempoverriden={settempoverriden}
              />
            </div>
          )}
        </div>
        <div style={{ float: "right" }}>
          {(electronApp || isAuthorized(user.hmi_role, GRAPHICS_WRITE)) && (
            <div style={styles.menu}>
              <ClearOverride
                tagid={ClearDigIds}
                tags={tags}
                settags={settags}
                option={3}
                title={"CLEAR ALL PSM4 DIGITAL OVERRIDES"}
                channel={"Clear All PSM4 Digital Overrides"}
                settempovrdata={settempovrdata}
                settempoverriden={settempoverriden}
                parentCallback={parentcallbackDig}
              />
              <ActivateOverride
                ovrdata={digovrdata}
                tags={tags}
                settags={settags}
                option={2}
                title={"ACTIVATE ALL PSM4 DIGITAL OVERRIDES"}
                channel={"Activate All PSM4 Digital Overrides"}
                parentCallback={parentcallbackDig}
                tempovrdata={tempovrdigdata}
                settempovrdata={settempovrdigdata}
                tempoverridden={tempoverridden}
                settempoverriden={settempoverriden}
              />
            </div>
          )}
          {/*</Button.Group>*/}
        </div>
        <div style={{ float: "left", marginLeft: "9%" }}>
          <h2 style={styles.header}>{display[0]}</h2>
        </div>
      </div>
      <div style={styles.div}>
        <svg width="2000" height="700">
          ;
          <REF rect={{ cx: 1350, cy: 150 }} /> {/* REF */}
          <HEX_SOFC_small
            rect={{ x: 1110, y: 175 }}
            type="horizontal"
            text="HEX070"
          />{" "}
          {/* FPS HEX070 */}
          <Stack_SOFC rect={{ x: 1515, y: 334 }} />
          <Valve
            rect={{ x: 680, y: 38 }}
            color={
              typeof data["34657"] !== "undefined" &&
              data["34657"] !== null &&
              data["34657"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV021 */}
          <HEX_SOFC_small
            rect={{ x: 1265, y: 485 }}
            type="horizontal"
            text="HEX110"
          />{" "}
          {/* HEX110 */}
          <Fan_Animate
            cx={880}
            cy={250}
            color={
              typeof data["34684"] !== "undefined" &&
              data !== null &&
              data["34684"] === 0
                ? "red"
                : "green"
            }
            toAnimate={
              typeof data["34684"] !== "undefined" &&
              data["34684"] !== null &&
              data["34684"] === 1
                ? "true"
                : "false"
            }
          />{" "}
          {/* VSD380POWER */}
          <HEX_SOFC
            rect={{ x: 1000, y: 320 }}
            type="horizontal"
            text="HEX370"
          />{" "}
          {/* HEX370 */}
          {/* NGLine  */}
          <text
            x={270}
            y={200}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="red"
          >
            NATURAL GAS
          </text>
          <Valve
            rect={{ x: 420, y: 165 }}
            color={
              typeof data["34654"] !== "undefined" &&
              data["34654"] !== null &&
              data["34654"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV011 */}
          {/*<Valve rect={{x:485, y:165}} color={(typeof data['40151'] !== 'undefined' && data['40151'] !== null ) ? colorByRange(40151) : 'grey'} />  /!* MFC012 : S300TS *!/*/}
          <ValveVertical
            rect={{ x: 617, y: 143 }}
            color={
              typeof data["34653"] !== "undefined" &&
              data["34653"] !== null &&
              data["34653"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV020 : S300TS */}
          <Valve
            rect={{ x: 680, y: 165 }}
            color={
              typeof data["21985"] !== "undefined" &&
              data["21985"] !== null &&
              data["21985"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV014 : 수정*/}
          <path
            d="M 350, 200 L 413, 200"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Natural gas to CV011 */}
          {/*<path d="M 456, 200 L 479, 200" stroke="red" strokeWidth={4} fill='none'/> /!* CV011 to CV012 *!/*/}
          <path
            d="M 456, 200 L 673, 200"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV012 to CV014 */}
          <path
            d="M 653, 200 L 653, 180 "
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* MFC012 to CV020*/}
          <path
            d="M 653, 136 L 653, 73 L 673, 73"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV020 to CV021 */}
          <path
            d="M 716, 73 L 1260, 73 L 1260, 155 L 1305, 155 L 1295, 145 L 1295, 155 "
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* TCV020 to REF*/}
          <path
            d="M 718, 200 L 1109, 200"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV014 to HEX070*/}
          <path
            d="M 1172, 200 L 1309, 200 "
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX070 to REF */}
          <path
            d="M 1390, 200 L 1420, 200 L 1420, 350 L 1510, 350 L 1500, 340 L 1500, 350"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Ref to Stack */}
          <path
            d="M 1626, 350 L 1753, 350 L 1753, 35 L 1240, 35 L 1240, 189 L 1175, 189 L 1185, 179 L 1185, 189"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Stack to HEX070 */}
          <path
            d="M 1109, 189 L 1075, 189 L 1075, 335 L 1042, 335"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX070 to HEX370 */}
          <path
            d="M 880, 274 L 880 335 L 998 335"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* BLO380 to CV380*/}
          <path
            d="M 880, 235 L 880 200 "
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* MIX020 to BLO380 */}
          <path
            d="M 1075, 235 L 1345, 235 L 1335, 225 L 1335, 235"
            stroke="red"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX070 to ATO marine*/}
          {/* N2 Purge Line  */}
          <text
            x={290}
            y={350}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="gray"
          >
            N2 PURGE
          </text>
          <path
            d="M 350, 350 L 745, 350 L 745, 395"
            stroke="gray"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/*N2 Purge to CV720*/}
          <path
            d="M 745, 350 L 745, 310 "
            stroke="gray"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/*N2 Purge to CV710*/}
          <path
            d="M 745, 270 L 745, 205 L 735, 215 L 745, 215 "
            stroke="gray"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/*CV720 to NG Line*/}
          <path
            d="M 745, 435 L 745, 490 L 735, 480 L 745, 480"
            stroke="gray"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/*CV710 to NG Air line*/}
          <ValveVertical
            rect={{ x: 710, y: 400 }}
            color={
              typeof data["21994"] !== "undefined" &&
              data["21994"] !== null &&
              data["21994"] === 1
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV710 */}
          <ValveVertical
            rect={{ x: 710, y: 273 }}
            color={
              typeof data["22000"] !== "undefined" &&
              data["22000"] !== null &&
              data["22000"] === 1
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV720 */}
          {/* DI Water Line  */}
          <text
            x={290}
            y={125}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="#0070C0"
          >
            DI WATER
          </text>
          <path
            d="M 350, 125 L 440, 125"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* DI Water to CV400 */}
          <Valve
            rect={{ x: 443, y: 90 }}
            color={
              typeof data["34663"] !== "undefined" &&
              data["34663"] !== null &&
              data["34663"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV400 */}
          <path
            d="M 479, 125 L 500, 125"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV400 to CV401 */}
          <Valve
            rect={{ x: 502, y: 90 }}
            color={
              typeof data["34666"] !== "undefined" &&
              data["34666"] !== null &&
              data["34666"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV401 */}
          <path
            d="M 538, 125 L 780, 125 L 1060, 125 L 1060, 310 L 1050, 320 L 1070, 320 L 1060, 310"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV401 NG Line */}
          {/* Air Line  */}
          <text
            x={290}
            y={500}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="green"
          >
            {" "}
            AIR{" "}
          </text>
          {/* <Valve rect={{x:492, y:465}} color={(typeof data !== 'undefined' && data !== null && data['99999'] === 1) ? 'red' : 'green'} />  CV110 : S300TS */}
          <Fan_Animate
            cx={438}
            cy={495}
            color={
              typeof data["34681"] !== "undefined" &&
              data["34681"] !== null &&
              data["34681"] === 0
                ? "red"
                : "green"
            }
            toAnimate={
              typeof data !== "undefined" &&
              data !== null &&
              data["34681"] === 1
                ? "true"
                : "false"
            }
          />{" "}
          {/* vsd110 power */}
          <path
            d="M 350, 500 L 420, 500"
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* AIR to BLO110 */}
          {/* <path d="M 460, 500 L 485, 500" stroke='green' strokeWidth={4} fill='none'/> BLO110 to CV110 */}
          <path
            d="M 460, 500 L 1263, 500 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/*CV110 to HEX110*/}
          <ValveVertical
            rect={{ x: 765, y: 410 }}
            color={
              typeof data["21991"] !== "undefined" &&
              data["21991"] !== null &&
              data["21991"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/* CV140 S300TS*/}
          <path
            d="M 800, 500 L 800, 445 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Air line to CV140 vertical*/}
          <path
            d="M 800, 403 L 800, 145 L 1073, 145 L 1305, 145 L 1295, 135 L 1295, 145 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV140 to REF */}
          <path
            d="M 1325, 500 L 1380, 500 L 1380, 380 L 1510, 380 L 1500, 370 L 1500, 380"
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX110 to stack */}
          <path
            d="M 1627, 380 L 1740, 380 L 1740, 140 L 1395, 140 L 1405, 130 L 1405, 140"
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* stack to ref */}
          <path
            d="M 800, 500 L 800, 445 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Air line to CV140 vertical*/}
          <path
            d="M 960, 500 L 960, 385 L 998, 385 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Air line to HEX370*/}
          <path
            d="M 1042, 385 L 1080, 385 L 1080, 500 "
            stroke="green"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX370 to Air Line*/}
          {/* EXHAUST LINE  */}
          <text
            x={290}
            y={600}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="yellow"
          >
            {" "}
            EXHAUST{" "}
          </text>
          <path
            d="M 1350, 210 L 1350, 330 L 1350, 515 L 1325, 515"
            stroke="yellow"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* Ref to HEX110 */}
          <path
            d="M 1265, 515 L 1160, 515 L 1160, 600 L 350, 600 L 360, 590 L 360, 600"
            stroke="yellow"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* HEX110 to EXHAUST */}
          <foreignObject x={400} y={213} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_digital_reverse(34654)} {/**CV011 */}
            </div>
          </foreignObject>
          <foreignObject x={470} y={213} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_analog_reverse(40151)} {/**MFC012 */}
            </div>
          </foreignObject>
          <foreignObject x={665} y={213} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_digital_reverse(21985)} {/**CV014 */}
            </div>
          </foreignObject>
          <foreignObject x={540} y={125} width={100} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital(34653)} {/**CV020 */}
            </div>
          </foreignObject>
          <foreignObject x={420} y={35} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital(34663)} {/**CV400 */}
            </div>
          </foreignObject>
          <foreignObject x={490} y={35} width={100} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital(34666)} {/**CV401 */}
            </div>
          </foreignObject>
          <foreignObject x={665} y={85} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_side(34657)} {/**CV021 */}
            </div>
          </foreignObject>
          <foreignObject x={635} y={275} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_reverse(22000)} {/**CV720 */}
            </div>
          </foreignObject>
          <foreignObject x={635} y={403} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_reverse(21994)} {/**CV710 */}
            </div>
          </foreignObject>
          <foreignObject x={815} y={410} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_reverse(21991)} {/**CV140 */}
            </div>
          </foreignObject>
          <foreignObject x={910} y={205} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_reverse(34684)} {/**VSD380 POWER */}
            </div>
          </foreignObject>
          <foreignObject x={910} y={260} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_analog_reverse(33775)} {/**VSD380 motor speed */}
            </div>
          </foreignObject>
          <foreignObject x={350} y={525} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_digital_reverse(34681)} {/**VSD110 POWER */}
            </div>
          </foreignObject>
          <foreignObject x={471} y={512} width={120} height={100}>
            <div style={{ width: "100%" }}>
              {grid_analog_reverse(33768)} {/**VSD110 motor speed */}
            </div>
          </foreignObject>
          <foreignObject x={1420} y={395} width={180} height={80}>
            <div style={{ height: "100%" }}>
              {grid(19458)} {/** TE110 */}
            </div>
          </foreignObject>
          180
          <foreignObject x={1635} y={395} width={180} height={80}>
            <div style={{ height: "100%" }}>
              {grid(19465)} {/** TE120 */}
            </div>
          </foreignObject>
          <foreignObject x={1630} y={290} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(18536)} {/** PDT310 */}
            </div>
          </foreignObject>
          <foreignObject x={1425} y={290} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(19381)} {/** TE300 */}
            </div>
          </foreignObject>
          <foreignObject x={1280} y={260} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(19409)} {/** TE910 */}
            </div>
          </foreignObject>
          {/**update 260129 */}
          <foreignObject x={1350} y={55} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(19416)} {/** TE900A */}
            </div>
          </foreignObject>
          <foreignObject x={1170} y={80} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(19430)} {/** TE090 */}
            </div>
          </foreignObject>
          <foreignObject x={1160} y={20} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(21187)} {/** TE090FT */}
            </div>
          </foreignObject>
          <foreignObject x={890} y={340} width={180} height={90}>
            <div style={{ height: "100%" }}>
              {grid(19402)} {/** TE380 */}
            </div>
          </foreignObject>
        </svg>
      </div>
      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
    marginTop: "0px",
  },
  grid: {
    marginTop: "5px",
  },
  name: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  unit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "18px",
  },
  gridUnit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "18px",
    paddingLeft: "5px",
  },
  row: {
    paddingTop: "0px",
    marginBottom: "0px",
    paddingBottom: "0px",
  },
  width: {
    maxWidth: "300px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "10px",
    width: "100%",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  header: {
    marginLeft: "10px",
    marginTop: "10px",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHasHeaderReceived: (hasHeaderReceived) =>
      dispatch(setHasHeaderReceived(hasHeaderReceived)),
  };
};

const mapStateToProps = (state) => {
  return {
    hasHeaderReceived: state.header.hasHeaderReceived,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PSMOvr_S300_PSM4);
